export default __webpack_public_path__ + "static/media/pandaSquare.ec439c3b.png";